/**
 * main.js
 * @description Module assignment
 */

// JS
import $ from 'jquery';
import "@babel/polyfill";
import CardCarousel from './app/CardCarousel';
import FeaturedCardCarousel from './app/FeaturedCardCarousel';
import Menu from './app/Menu';
import JumpLink from './app/JumpLink';
import RepDrawer from './app/Drawer';
import StackingCards from './app/StackingCards';
import SlideNav from './app/SlideNav';
import FooterReveal from './app/FooterReveal';
import Collapse from './app/Collapse';
import ScrollTo from './app/ScrollTo';
import CardStackToggle from './app/CardStackToggle';
import ImagesLoaded from './app/ImagesLoaded';
import ScrollEvents from './app/ScrollEvents';
import CardModal from './app/CardModal';
import TextHighlight from './app/TextHighlight';
import CardOptions from './app/CardOptions';
import { gsap, ScrollTrigger, ScrollToPlugin } from 'gsap/all';
import DrawSVGPlugin from './vendor/gsap/DrawSVGPlugin';
import CustomEase from './vendor/gsap/CustomEase';
import { attachCardTypeContent } from './app/CardTypes';
import barba from '@barba/core';

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(CustomEase);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

window.gsap = gsap;
window.CustomEase = CustomEase;

const init = ()=> {
  const { barbaNamespace } = $('[data-barba="container"]').data();
  const index = $('.primary-nav.slide-nav').find(`[href="${window.location.href}"]`).index();
  if (index > -1) {
    $('[data-current-program]').attr('data-current-program', index).data('current-program', index);
    $('[data-start]:not(.drawer-navigation)').attr('data-start', index).data('start', 0);
    $(`[data-sample-state=${index}]`).trigger('click');
  }
  if (barbaNamespace  !== 'home' ){
    $('.sample-view').removeClass('hidden');
    $('.rep-drawer .slide-nav').removeClass('lg:hidden');
  } else {
    $('.sample-view').addClass('hidden');
    $('.rep-drawer .slide-nav').addClass('lg:hidden');
    $('[data-start]').attr('data-start', 'home');
  }

  new CardCarousel();
  new FeaturedCardCarousel();
  new ScrollEvents();
  new ImagesLoaded();
  new ScrollTo();
  new JumpLink();
  new RepDrawer();

  $('.card-stack').each((_, element) => new StackingCards(element));

  $('[data-target="card-modal"]').each((_, el) => {
    new CardModal(el)
  })

  $('.stack-comparison').each( (_, element) => {
    new CardStackToggle(element);
  })

  $('.featured-card').each((_, el) => {
    const $el = $(el);
    attachCardTypeContent($el, $el.find('.featured-card-content')[0], 'featured-card');
  })

  $('.slide-nav').each((_, el) => {
    new SlideNav(el);
  });

  $('.text-highlight').each((_, el) => {
    new TextHighlight(el);
  });

  $('[data-target="card-options"]').each((_, el) => {
    new CardOptions(el);
  });
}

barba.hooks.after((data)=> {
  gsap.to(window, {
    duration: .5,
    scrollTo: {
      y: 0,
    },
  });
  // update menu jump navs
  const $html = $(data.next.html);
  let html = $html.find('.desktop-jump-nav').html();
  $('.desktop-jump-nav').html(html);
  html = $html.find('.mobile-jump-nav').html();
  $('.mobile-jump-nav').html(html);
  const nextProgramHtml = $html.find('#next-program-html').html() ? $html.find('#next-program-html').html().trim() : '';
  $('#next-program-module').html(nextProgramHtml);
  const nextNavButtonsHtml = $html.find('#nav-buttons').html() ? $html.find('#nav-buttons').html().trim() : '';
  $('#nav-buttons').html(nextNavButtonsHtml);
  const mobileNextNavButtonsHtml = $html.find('#mobile-nav-buttons').html() ? $html.find('#mobile-nav-buttons').html().trim() : '';
  $('#mobile-nav-buttons').html(mobileNextNavButtonsHtml);
  $('#footer').toggleClass('footer-only', nextProgramHtml.length === 0);

  //update
  $('.update_drawer_block').html($html.find('.update_drawer_block').html());

  new FooterReveal();
  init();
});
barba.init({
  prevent: ({ el }) => document.getElementById('wpadminbar') ? document.getElementById('wpadminbar').contains(el) : false
});

$(()=> {
  new FooterReveal();
  new Collapse();
  new Menu();
  init();
});
